import { render } from "./CourseRequiredAlert.vue?vue&type=template&id=9cc88e5e&scoped=true"
import script from "./CourseRequiredAlert.vue?vue&type=script&lang=js"
export * from "./CourseRequiredAlert.vue?vue&type=script&lang=js"

import "./CourseRequiredAlert.vue?vue&type=style&index=0&id=9cc88e5e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc88e5e"]])

export default __exports__